import { t } from 'i18next';
import { memo } from 'react';
import { ResourceSummary } from '../../../common/components/ResourceSummary';
import { ResourceInfoItem } from '../../../common/components/ResourceSummaryInfo';
import { getOperationContextLabel } from '../../../common/operations/enums/OperationContext';
import { getOperationTypeLabel } from '../../../common/operations/enums/OperationType';
import { DateUtils } from '../../../common/utils/DateUtils';
import { Interpolation } from '../../../config/i18n/components/Interpolation';
import { OperationDetail } from '../models/OperationDetail';

type Props = {
  operationId: number;
  operation: OperationDetail | null;
};

const createOperationSummary = (operation: OperationDetail | null): ResourceInfoItem[] | null => {
  if (operation === null) return null;

  const timestamp = operation.getTimestamp();
  const firstCallSite = operation.getFirstCallSite();
  const methodName = firstCallSite?.getFullMethodName();
  const algorithms = operation.getAlgorithms();

  const items: ResourceInfoItem[] = [
    { name: t('type'), data: getOperationTypeLabel(operation.getType()) },
    { name: t('context'), data: getOperationContextLabel(operation.getContext()) },
    { name: t('algorithms'), data: algorithms.length > 0 ? algorithms.join(', ') : t('none') },
  ];
  if (timestamp) {
    items.push({ name: t('timestamp'), data: DateUtils.toTimestampString(timestamp) });
  }
  if (firstCallSite) {
    items.push({ name: t('callSite'), data: methodName ? <Interpolation>{`<code>${methodName}</code>`}</Interpolation> : t('unknown') });
  }
  return items;
};

export const OperationSummary = memo(({ operation, operationId }: Props) => {
  const loading = operation === null;
  const items = createOperationSummary(operation);

  return (
    <ResourceSummary
      title={t('detailsForOperationId', { operationId })}
      loading={loading}
      items={items}
      value={operation?.getValueJson() ?? null}
      metadataValue={null}
      valueTitle=""
      metadataTitle=""
      leftWidth={6}
    />
  );
});
